import { render, staticRenderFns } from "./exame.vue?vue&type=template&id=47e166ce&scoped=true"
import script from "./exame.vue?vue&type=script&lang=js"
export * from "./exame.vue?vue&type=script&lang=js"
import style0 from "./exame.vue?vue&type=style&index=0&id=47e166ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e166ce",
  null
  
)

export default component.exports